import CommonTable, { type TableColumn } from '@/components/common/CommonTable'
import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import { RoutesLink } from '@/utility/RouteLinks'
import { Eye, Pencil, Plus } from 'lucide-react'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from "@/components/ui/button"
import { useState } from 'react'
import EmployeeOnBoardService from '@/services/EmployeeOnBoard/EmployeeOnBoardService'
import { ThrowError } from '@/api/callApi'
// import type { IUser } from '@/interface/employeeOnBoard'
import { API_URL } from '@/api/constant'
import type { IOAuthClient, IUser } from '@/interface/employeeOnBoard'
import moment from 'moment'
// import { IUser } from '@/interface/employeeOnBoard'

const Employees: React.FC = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [employees, setEmployees] = useState<IUser[]>([]);
    const handleGetEmployees = async () => {
        setIsLoading(true)
        try {
            const response = await EmployeeOnBoardService.getAllEmployees()
            if (response?.status) {
                setEmployees(response.data.user)
                console.log("resssssssssssssss", response.data.user)
            }
        } catch (error) {
            ThrowError(error)
        } finally {
            setIsLoading(false)
        }
    }
    useEffect(() => {
        handleGetEmployees()
    }, [])
    const columns: TableColumn<IUser>[] = [
        {
            key: 'empId',
            header: 'Emp ID',
            render: (item: IUser) => (
                <span className="text-muted-foreground font-medium">#{item?.employeeCode}</span>
            )
        },
        {
            key: 'profilePhoto',
            header: 'Profile Photo',
            render: (item: IUser) => (
                <span className="text-muted-foreground font-medium">{item?.profilePhoto ? <img src={API_URL + "/" + item?.profilePhoto} alt="" className='h-10 w-10 rounded-full' /> : 'N/A'}</span>
            )
        },
        {
            key: 'name',
            header: 'Name',
            render: (item: IUser) => (
                <div className="flex items-center gap-3">
                    {/* <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold shadow-sm">
                        {item?.name?.charAt(0)?.toUpperCase() || 'E'}
                    </div> */}
                    <span className="font-semibold capitalize">{item?.name}</span>
                </div>
            )
        },
        {
            key: 'email',
            header: 'Email',
            render: (item: IUser) => (
                <span className="font-medium text-gray-700">{item?.email}</span>
            )
        },
        {
            key: 'phone',
            header: 'Phone',
            render: (item: IUser) => (
                <span className="font-medium text-gray-700">{item?.phone}</span>
            )
        },
        {
            key: 'department',
            header: 'Department',
            render: (item: IUser) => (
                <span className="font-medium text-gray-700">{item?.department?.name}</span>
            )
        },
        {
            key: 'designation',
            header: 'Designation',
            render: (item: IUser) => (
                <span className="text-gray-600">{item?.designation?.name}</span>
            )
        },
        {
            key: 'shift',
            header: 'Shift',
            render: (item: IUser) => (
                <span className="px-2.5 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium border border-gray-200">
                    {item?.shift?.shiftName}
                </span>
            )
        },
        {
            key: 'ApplicableCTC',
            header: 'Applicable CTC',
            render: (item: IUser) => (
                <span className="text-gray-600">{item?.oauthClients?.map((client: IOAuthClient) => client?.name).join(', ')}</span>
            )
        },
        {
            key: 'joiningDate',
            header: 'Joining Date',
            render: (item: IUser) => (
                <span className="font-medium text-gray-700">{item?.joiningDate ? moment(item?.joiningDate).format('DD-MM-YYYY') : 'N/A'}</span>

            )
        },
        {
            key: 'status',
            header: 'Status',
            render: (item: IUser) => (
                <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded-full ${item?.status?.toLowerCase() === 'current' ? 'text-green-600 border-green-600 bg-green-50' : 'text-destructive border-destructive bg-destructive/10'}`}>
                    {item?.status}
                </span>
            )
        },
        {
            key: 'actions',
            header: 'Actions',
            render: (item: IUser) => (
                <div className="flex gap-2">

                    <Button
                        size={'icon'}
                        className="bg-primary/10 text-primary hover:bg-primary/20"
                        title="View Employee"
                        onClick={() => {
                            console.log("View Employee Clicked - RoutesLink.employeeDetail:", RoutesLink.employeeDetail, "item.id:", item?.id, "item:", item);
                            navigate(`${RoutesLink.employeeDetail}/${item.id}`);
                        }}
                    >
                        <Eye size={18} />
                    </Button>
                    <Button
                        size={'icon'}
                        className="bg-primary/10 text-primary hover:bg-primary/20"
                        title="Edit Employee"
                        onClick={() => navigate(`${RoutesLink.editEmployee}/${item.id}`)}
                    >
                        <Pencil size={18} />
                    </Button>

                    {/* <Button
                        size={'icon'}
                        className="bg-destructive/10 text-destructive hover:bg-destructive/20"
                        title="Delete Employee"
                    >
                        <Trash size={18} />
                    </Button> */}
                </div>
            ),
        },
    ]
    // const data: any[] = [
    //     {
    //         empId: '1',
    //         name: 'John Doe',
    //         department: 'IT',
    //         designation: 'Developer',
    //         shift: 'Day',
    //         grossCtc: '100000',
    //         status: 'Active',
    //     },

    // ]
    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title='Employees'
                    buttonText='Add Employee'
                    buttonIcon={<Plus />}
                    onClick={() => { navigate(RoutesLink.createEmployee) }}
                />
                <CommonTable data={employees} columns={columns} loading={isLoading} />

            </div>
        </Layout>
    )
}

export default Employees